export default __webpack_public_path__ + "static/media/IS.e25db82d.svg";